import type { GetIndicatorByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIndicatorByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIndicatorByIdArgs = {
  id: string;
};

export const useLazyGetIndicatorById = createLazyQueryHook<
  UseLazyGetIndicatorByIdArgs,
  GetIndicatorByIdResponseRow[],
  GetIndicatorByIdQuery
>({
  trpcQuery: (client, { id }) =>
    client.frontend.indicator.indicatorById.query({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator: data ?? [] }),
  graphqlDocument: GetIndicatorByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
  graphqlFetchPolicy: 'no-cache',
});
